import { decodeCommentText } from "@ext/markdown/elements/sourceComment/logic/commentText";

const sourceCommentToken = (node: "source-comment" | "inline-source-comment") => ({
	node,
	getAttrs: (tok) => ({ text: decodeCommentText(tok.attrs?.hex ?? "") }),
});

export default sourceCommentToken;
